import { setCookie } from '../utils/cookie-manager.js';

const SELECTORS = {
    CONTAINER: '.js-page-head-msg',
    CLOSE: '.js-page-head-msg__close'
};
const COOKIE_NAME = 'dm_head_msg_hidden';

class PageHeadMessage {
    constructor(container) {
        this.container = container;
        this.closeButton = container.querySelector(SELECTORS.CLOSE);
        this.closeButton.addEventListener('click', this.handleClose.bind(this), { once: true });
    }

    handleClose() {
        this.container.classList.add('is-hidden');
        setCookie(COOKIE_NAME, true);
    }
}

[].forEach.call(document.querySelectorAll(SELECTORS.CONTAINER), item => new PageHeadMessage(item));
